import axiosApi from "@/axiosApi/api.config";

export const postContactUs = async (data) => {
  try {
    const response = await axiosApi.post("/common/contact-us", data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const getPaginatedBlogs = async (page = 1, limit = 6) => {
  try {
    const response = await axiosApi.get(`/common/blogs/paginate?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const getBlogBySlug = async (slug) => {
  try {
    const response = await axiosApi.get(`/common/blogs/${slug}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const getHomeBlog = async () => {
  try {
    const response = await axiosApi.get(`/common/blogs/home`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const getJobs = async () => {
  try {
    const response = await axiosApi.get("/common/jobs");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const getJobBySlug = async (slug) => {
  try {
    const response = await axiosApi.get(`/common/jobs/${slug}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const postApplyJob = async (formData) => {
  try {
    const response = await axiosApi.post("/common/jobs/apply", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const getPageContentBySlug = async (slug) => {
  try {
    const response = await axiosApi.get(`/common/pages/${slug}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};


